import { createGlobalStyle } from "styled-components";

/** driver.js draws its popover outside React, so it can only be styled globally, through its class. */
export const DriverTourStyles = createGlobalStyle`
  .driver-popover.mike-tour {
    font-family: inherit;
    color: ${(props) => props.theme.colors.font.grey1};
    border-radius: ${(props) => props.theme.box.borderRadius};
    min-width: 400px;
    max-width: 480px;
    padding: ${(props) => `calc(${props.theme.spacing.medium} + ${props.theme.spacing.xsmall})`};
  }

  .driver-popover.mike-tour .driver-popover-title {
    font-size: ${(props) => props.theme.fontSizes.large};
    /* Keeps a long title clear of the close button. */
    padding-right: ${(props) => props.theme.spacing.medium};
  }

  .driver-popover.mike-tour .driver-popover-description {
    font-size: ${(props) => props.theme.fontSizes.medium};
    color: ${(props) => props.theme.colors.font.tertiary};
  }

  .driver-popover.mike-tour .driver-popover-progress-text {
    font-size: ${(props) => props.theme.fontSizes.small};
  }

  .driver-popover.mike-tour .driver-popover-footer-btn {
    font-size: ${(props) => props.theme.fontSizes.small};
    border-radius: ${(props) => props.theme.box.borderRadius};
    padding: ${(props) => `${props.theme.spacing.xsmall} ${props.theme.spacing.small}`};
  }

  .driver-popover.mike-tour .driver-popover-next-btn {
    background-color: ${(props) => props.theme.background.primary};
    border-color: ${(props) => props.theme.background.primary};
    color: ${(props) => props.theme.colors.font.secondary};
  }
`;
